import { useState, useEffect } from "react";
//Bootstrap
import { Container, Row, Col, Card, Table } from "react-bootstrap";
//Components
import { useModal } from "../../../hooks/useModal";
import ModalAlert from "../../../components/Modals/ModalAlert";
import CenterSpinner from "../../../components/Tools/Basics/Spinner";
//API
import { urlGetDetalleOperativoSaf } from "../../../api/URLs/operativos";
import { axiosWithAuth } from "../../../api/axiosConfig";

const DetalleOperativosSAF = ({ codope }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { handleError, showModal, modalType, msjModal, handleClose } =
    useModal();

  const fetchDetalleOperativo = async () => {
    try {
      setLoading(true);
      const response = await axiosWithAuth.get(
        urlGetDetalleOperativoSaf + codope
      );
      setData(response.data);
    } catch (error) {
      const auxError = error.response?.data?.msj
        ? error.response.data.msj
        : "Error al cargar los datos del reporte";
      handleError(auxError);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetalleOperativo();
  }, []);

  if ((!data || data.length === 0) && !loading) {
    return <h3>No hay datos</h3>;
  }
  if (loading) {
    return <CenterSpinner />;
  }

  const totalViajes = data.reduce((acc, item) => acc + (item.viajes || 0), 0);
  const totalKilos = parseFloat(
    (data.reduce((acc, item) => acc + (item.kilos || 0), 0) / 1000).toFixed(2)
  );
  return (
    <Container fluid className="p-3">
      <h3 className="mb-2 text-center text-md-start">
        <b>Detalle de Operativo - {codope}</b>
      </h3>
      <Card className="operational-report">
        <Card.Body>
          {data && (
            <>
              {/* Header Section */}
              <div className="report-header mb-3">
                <Row>
                  <Col xs={12} md={7} className="report-info">
                    <Row className="mb-2">
                      <Col xs={5} md={3} className="header-label">
                        Operativo:
                      </Col>
                      <Col xs={7} md={9} className="header-value fw-bold">
                        {data[0]?.nomope.trim()}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={5} md={3} className="header-label">
                        Desestiba:
                      </Col>
                      <Col xs={7} md={9} className="header-value">
                        {data[0]?.desestiba.trim() === "N" ? "No" : "Sí"}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={5} md={3} className="header-label">
                        Cliente:
                      </Col>
                      <Col xs={7} md={9} className="header-value">
                        {data[0]?.nomempre}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5} md={3} className="header-label">
                        Producto:
                      </Col>
                      <Col xs={7} md={9} className="header-value">
                        {data[0]?.nompro}
                      </Col>
                    </Row>
                  </Col>
                  {/* Si quieres mostrar meta info, puedes agregar otro <Col xs={12} md={5}> aquí */}
                </Row>
                <hr className="mt-3 mb-2" />
              </div>

              {/* Table Section */}
              <div className="report-table mb-3">
                <Table bordered responsive className="mb-0">
                  <thead>
                    <tr className="text-center">
                      <th>Turno</th>
                      <th>Total de Viajes</th>
                      <th>Total de Kilos</th>
                      <th>Unidad Negocio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((turno, index) => (
                      <tr key={index} className="text-center">
                        <td className="text-start">{turno.nomturno.trim()}</td>
                        <td>{turno.viajes}</td>
                        <td>{turno.kilos}</td>
                        <td>{turno.un.trim()}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Footer Section */}
              <div className="report-footer">
                <Row className="totals-row mb-3">
                  <Col
                    xs={12}
                    md={6}
                    className="d-flex justify-content-center mb-2 mb-md-0"
                  >
                    <div className="total-box">
                      <span>Total de Viajes: {totalViajes}</span>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="d-flex justify-content-center">
                    <div className="total-box">
                      <span>Total de Toneladas: {totalKilos}</span>
                    </div>
                  </Col>
                </Row>

                <div className="observations mb-3">
                  <div className="observation-label">Observaciones:</div>
                  <div className="observation-content">
                    {data[0]?.obs.trim() || "No hay observaciones"}
                  </div>
                </div>

                <hr className="footer-divider" />
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Error Modal */}
      <ModalAlert
        show={showModal}
        modalType={modalType}
        msjModal={msjModal}
        handleClose={handleClose}
      />
    </Container>
  );
};

export default DetalleOperativosSAF;
